import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, useTheme } from 'react-native-paper';
import PropTypes from 'prop-types';

const LAST_PAGE = 6;

const BUTTON_TITLES = {
  en: [
    { back: '', next: '' },
    { back: 'BACK', next: 'NEXT' },
    { back: 'BACK', next: 'NEXT' },
    { back: 'BACK', next: 'NEXT' },
    { back: 'BACK', next: 'NEXT' },
    { back: 'BACK', next: 'RESET' },
  ],
  es: [
    { back: '', next: '' },
    { back: 'PREVIO', next: 'SIGUIENTE' },
    { back: 'PREVIO', next: 'SIGUIENTE' },
    { back: 'PREVIO', next: 'SIGUIENTE' },
    { back: 'PREVIO', next: 'SIGUIENTE' },
    { back: 'PREVIO', next: 'REINICIAR' },
  ],
  qu: [
    { back: '', next: '' },
    { back: 'QIPAMAN', next: 'ÑAUPAQMAN' },
    { back: 'QIPAMAN', next: 'ÑAUPAQMAN' },
    { back: 'QIPAMAN', next: 'ÑAUPAQMAN' },
    { back: 'QIPAMAN', next: 'ÑAUPAQMAN' },
    { back: 'QIPAMAN', next: 'WAQMANTA' },
  ],
};

export default function Navigation(props) {
  const {
    currentPage,
    disableNextStep,
    formikActions,
    language,
    stepBackward,
    stepForward,
    updatePage,
  } = props;

  function handleReset() {
    formikActions.handleReset();
  }

  function handleSubmit() {
    formikActions.handleSubmit();
  }

  const { colors } = useTheme();

  return (
    <View style={styles.buttonGroup}>
      <Button
        mode="text"
        color={colors.accent}
        onPress={stepBackward}
        labelStyle={{ fontWeight: 'bold' }}
      >
        {BUTTON_TITLES[language][currentPage].back}
      </Button>
      {currentPage < LAST_PAGE ? (
        <Button
          mode="text"
          color={colors.accent}
          labelStyle={{ fontWeight: 'bold' }}
          onPress={() => {
            if (currentPage === 2) handleSubmit();
            if (currentPage === 5) {
              handleReset();
              updatePage(1);
            } else {
              stepForward();
            }
          }}
          disabled={
            disableNextStep || (formikActions && formikActions.isSubmitting)
          }
        >
          {BUTTON_TITLES[language][currentPage].next}
        </Button>
      ) : null}
    </View>
  );
}
const styles = StyleSheet.create({
  buttonGroup: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

Navigation.propTypes = {
  currentPage: PropTypes.number,
  disableStep: PropTypes.bool,
  formikContext: PropTypes.object,
  language: PropTypes.string,
  stepBackward: PropTypes.func,
  stepForward: PropTypes.func,
  updatePage: PropTypes.func,
};
